import React from 'react'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import LineHistoryIcon from 'LuxKit/Icons/line/LineHistoryIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

const DeletedTileContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${rem(12)};
  padding: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.S};
  background: ${props => props.theme.palette.neutral.default.seven};

  ${mediaQueryUp.tablet} {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

interface Props {
  title: string
  onUndoClick: () => void
}

function UndoDeletedItemsTile({ title, onUndoClick }: Props) {
  return (
    <DeletedTileContainer>
      <Group direction="vertical" gap={4}>
        <BodyText wrap="truncate" variant="medium" weight="bold">{title}</BodyText>
        <BodyText variant="medium" colour="neutral-two">was deleted from your cart</BodyText>
      </Group>
      <TextButton
        kind="secondary"
        size="small"
        shape="round"
        startIcon={<LineHistoryIcon />}
        onClick={onUndoClick}
      >
        Undo
      </TextButton>
    </DeletedTileContainer>
  )
}

export default UndoDeletedItemsTile
